<template>
    <div class="buyCert">
        <div class="title">购买证书</div>
        <div class="cert_mess">
            <div class="for" v-for="(item,index) in certData" :key="index" @click="handlCheckPay(item)">
                <div class="money"><span>￥</span>{{item.price}}</div>
                <div class="seal">{{item.shopName}}</div>
                <div class="btn">立即购买</div>
                <div class="ukey" v-show="item.ukey == 1 && $route.params.state == 1">ukey</div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                certData: [],
                signatureId: ''
            }
        },
        mounted() {
            //印章id，添加订单必传
            this.signatureId = this.$route.query.signatureId;
            this.getData();
        },
        methods: {
            getData() {
                let _this = this;
                let param = new FormData();
                if (this.$route.params.state == 0) {
                    param.append('type', 0);
                } else {
                    param.append('type', 1);
                }
                _this.api.getCertList(param).then(res => {
                    console.log(res)
                    _this.certData = res.data;
                })
            },
            handlCheckPay(item) {
                let _this = this;
                let state = 0;
                if (item.shopName.indexOf('天') != -1) {
                    state = 1;
                }
                _this.$router.push({
                    name: 'payCert',
                    query: {
                        orderList: JSON.stringify(item),
                        signatureId: this.signatureId
                    }
                });
            }
        }
    }
</script>

<style scoped lang="less">
    @import '../../../../static/less/xm.less';

    .buyCert {
        width: @a;
        height: auto;
        margin-left: 4%;

        .title {
            width: @a;
            height: 24px;
            font-family: MicrosoftYaHei-Bold;
            font-size: 24px;
            font-weight: normal;
            font-stretch: normal;
            letter-spacing: 1px;
            color: #333333;
        }

        .cert_mess {
            width: 963px;
            height: auto;
            padding-left: 123px;
            margin-top: 8px;
            overflow: hidden;
            zoom: 1;

            .for:nth-child(3n + 1) {
                margin-left: 0;
            }

            .for:hover {
                background-image: linear-gradient(270deg,
                #1e6eee 0%,
                #109ee7 50%,
                #01cee0 100%),
                linear-gradient(#ffffff,
                #ffffff);
                background-blend-mode: normal,
                normal;
                box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                border-radius: 20px;
                color: #fff;
                cursor: pointer;
            }

            .for {
                width: 260px;
                height: 180px;
                background-color: #ffffff;
                border-radius: 20px;
                border: solid 1px #aaaaaa;
                float: left;
                color: #333333;
                @column();
                margin-left: 30px;
                margin-top: 30px;
                position: relative;
                overflow: hidden;

                .ukey {
                    width: 40px;
                    height: 40px;
                    position: absolute;
                    top: 0;
                    right: 0;
                    @row();
                    border-radius: 50%;
                    background-image: linear-gradient(270deg,
                    #1e6eee 0%,
                    #109ee7 50%,
                    #01cee0 100%),
                    linear-gradient(#ffffff,
                    #ffffff);
                    background-blend-mode: normal,
                    normal;
                    box-shadow: 0px 0px 20px 0px rgba(33, 161, 219, 0.5);
                    color: #fff;
                }

                .money {
                    font-family: MicrosoftYaHei-Bold;
                    font-size: 24px;
                    font-weight: bolder;
                    letter-spacing: 1px;

                    span {
                        font-family: MicrosoftYaHei;
                        font-size: 18px;
                        font-weight: normal;
                        font-stretch: normal;
                        letter-spacing: 1px;
                    }
                }

                .seal {
                    font-family: MicrosoftYaHei;
                    font-size: 18px;
                    font-weight: normal;
                    font-stretch: normal;
                    letter-spacing: 1px;
                    margin-top: 24px;
                }

                .btn {
                    width: 100px;
                    height: 30px;
                    background-color: #fff;
                    border-radius: 15px;
                    border: solid 1px #aaaaaa;
                    letter-spacing: 1px;
                    line-height: 30px;
                    text-align: center;
                    color: #333333;
                    margin-top: 22px;
                }
            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/components/page/certificate/buyCert.vue